import { render, staticRenderFns } from "./HeaderButtons.vue?vue&type=template&id=0f575853&scoped=true&"
import script from "./HeaderButtons.vue?vue&type=script&lang=js&"
export * from "./HeaderButtons.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./HeaderButtons.vue?vue&type=style&index=0&id=0f575853&lang=scss&scoped=true&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "0f575853",
  null
  ,true
)

export default component.exports